var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7.0002L5.40005 25.0002C5.40005 25.1002 5.30005 25.2002 5.30005 25.3002C5.30005 25.6002 5.60005 25.9002 5.90005 25.9002H26C26.3 25.9002 26.6 25.6002 26.6 25.3002C26.6 25.2002 26.6 25.1002 26.5 25.0002L16.5 7.0002C16.4 6.8002 16.2 6.7002 16 6.7002C15.8 6.7002 15.6 6.8002 15.5 7.0002ZM17.2 23.2002C17.2 23.4002 17.1 23.5002 16.9 23.5002H15.1C14.9 23.5002 14.8 23.4002 14.8 23.2002V21.4002C14.8 21.2002 14.9 21.1002 15.1 21.1002H16.9C17.1 21.1002 17.2 21.2002 17.2 21.4002V23.2002ZM17.2 19.6002C17.2 19.8002 17.1 19.9002 16.9 19.9002H15.1C14.9 19.9002 14.8 19.8002 14.8 19.6002V12.4002C14.8 12.2002 14.9 12.1002 15.1 12.1002H16.9C17.1 12.1002 17.2 12.2002 17.2 12.4002V19.6002Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRed);
export default __webpack_public_path__ + "static/media/error_red.f925f5ddd8a6f4b2873d2722e9512a5a.svg";
export { ForwardRef as ReactComponent };